import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { DETALHAMENTO_OPERACAO_SEM_NOTA_FISCAL_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    DETALHAMENTO_OPERACAO_SEM_NOTA_FISCAL_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    DETALHAMENTO_OPERACAO_SEM_NOTA_FISCAL_ENDPOINT,
    id
  ]);
}
